// Вкладки карточки РЕМОНТА, перенесённые из Office (dict/remont-edit). Формат — см. request.js.
// Права-вкладки: office_api/office_port/areas/requests/ep_remont_card.py (TAB_GRANTS).
// Блоки, дописанные в существующие вкладки My Space, лежат в ./rmBlocks: StageActions («Этапы»),
// GprPause («ГПР»), PaymentSummary («Платежи»).
import { defineAsyncComponent } from "vue";

export const tabsCodes = {
  OA__RemontFormOfficeRemontCommonTab: "rmCommon",
  OA__RemontFormOfficeBrigadeTab: "rmBrigade",
  OA__RemontFormOfficeShStageTab: "rmShStages",
  OA__RemontFormOfficeSmetaDiffTab: "rmSmetaDiff",
  OA__RemontFormOfficeManagerCheckTab: "rmManagerCheck",
};

export const components = {
  rmCommon: defineAsyncComponent(() => import("./rmCommon/index.vue")),
  rmBrigade: defineAsyncComponent(() => import("./rmBrigade/index.vue")),
  rmShStages: defineAsyncComponent(() => import("./rmShStages/index.vue")),
  rmSmetaDiff: defineAsyncComponent(() => import("./rmSmetaDiff/index.vue")),
  rmManagerCheck: defineAsyncComponent(() => import("./rmManagerCheck/index.vue")),
};

export const groups = {
  progress: ["rmCommon", "rmBrigade", "rmShStages", "rmManagerCheck"],
  materials: ["rmSmetaDiff"],
};

export const aliases = {
  rmCommon: "общее ремонт даты цена бригадир рейтинг оценка спецификация гпр финальный проект",
  rmBrigade: "мастера бригада",
  rmShStages: "умный дом уд",
  rmSmetaDiff: "расхождение смета отгрузка",
  rmManagerCheck: "работы мп менеджер проекта чек-лист",
};
